import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-typography',
  templateUrl: './typography.component.html',
  styleUrls: ['./typography.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TypographyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
